/* eslint-disable no-multi-spaces */

import { matchPath } from 'react-router-dom';

// Internal routes — react-router path patterns (`:param` tokens); use generatePath() to interpolate.
// For service-code → context-varying destinations resolved at runtime, use serviceRoutes.js + useUrlResolver instead.
export const accountNotFound = '/dashboard/account-not-found';
export const accountPayments = '/dashboard/account/payments';
export const accountSettings = '/dashboard/account/settings';
export const amendments = '/dashboard/:businessEntityUuid/amendments';
export const annualReports = '/dashboard/:businessEntityUuid/annual-reports';
export const appTemplate = '/d/x/*'; // TODO: change with new restructured URL
export const assistantUI = '/dashboard/:businessEntityUuid/guide/*';
export const bankingUI = '/dashboard/:businessEntityUuid/banking/*';
export const bankOfAmericaOffer = '/dashboard/:businessEntityUuid/beneficial-ownership';
export const beneficialOwnership = '/dashboard/:businessEntityUuid/beneficial-ownership';
export const billing = '/dashboard/subscription-hub/billing/*';
export const billingPaymentMethods = '/dashboard/subscription-hub/billing/methods';
export const billingSubscriptions = '/dashboard/subscription-hub/billing/subscriptions';
export const billingHistory = '/dashboard/:businessEntityUuid/subscription-hub/billing-history';
export const orderHistory = '/dashboard/:businessEntityUuid/subscription-hub/orders';
export const businessDocuments = '/dashboard/:businessEntityUuid/documents/business-documents/*';
export const businessOverview = '/dashboard/companies';
export const businessProfile = '/dashboard/:businessEntityUuid/business-profile';
export const callback = '/dashboard/callback';
export const dashboard = '/dashboard/';
export const documentTemplates = '/dashboard/:businessEntityUuid/documents/document-templates/*';
export const download = '/dashboard/download';
export const education = '/dashboard/:businessEntityUuid/education/*';
export const entities = '/dashboard/companies';
export const entity = '/dashboard/:businessEntityUuid';
export const entityBanking = '/dashboard/:businessEntityUuid/banking/*';
export const entityBusinessDocuments = '/dashboard/:businessEntityUuid/documents/business-documents/*';
export const entityCompliance = '/dashboard/:businessEntityUuid/compliance/*';
export const entityDocumentTemplates = '/dashboard/:businessEntityUuid/documents/document-templates/*';
export const entityInvoicing = '/dashboard/:businessEntityUuid/invoicing/*';
export const entityMarketingTools = '/dashboard/:businessEntityUuid/marketing-tools/*';
export const entityProducts = '/dashboard/:businessEntityUuid/products';
export const entityProductLanding = '/dashboard/:businessEntityUuid/products/:productId';
export const entityMoney = '/dashboard/:businessEntityUuid/money/*';
export const entityFinanceHub = '/dashboard/:businessEntityUuid/finances';
export const entityFinanceHubLinkedAccounts = '/dashboard/:businessEntityUuid/finances/linked-accounts';
export const entityOrders = '/dashboard/:businessEntityUuid/subscription-hub/orders/*';
export const entityProfile = '/dashboard/:businessEntityUuid/business-profile';
export const entitySubscriptionCancel = '/dashboard/:businessEntityUuid/subscription-cancel/:orderBillingItemUuid';
export const entitySubscriptionRestart = '/dashboard/:businessEntityUuid/subscription-restart/:orderBillingItemUuid';
/** Subscriptions list in ecomm (subscription-hub MFE); includes /billing/ segment. */
export const entitySubscriptions = '/dashboard/:businessEntityUuid/subscription-hub/billing/subscriptions';
export const entityBillingPaymentMethods = '/dashboard/:businessEntityUuid/subscription-hub/billing/methods';
export const entityHelp = '/dashboard/:businessEntityUuid/help';
export const entityWebsites = '/dashboard/:businessEntityUuid/marketing-tools/websites/*';
export const entityWorryFreeCompliance = '/dashboard/:businessEntityUuid/worry-free-compliance';
export const financialReadiness = '/dashboard/financial-readiness';
export const getStarted = '/dashboard/get-started';
export const help = '/dashboard/help';
export const invoicePayment = '/dashboard/invoice/payment/:accountUuid';
export const invoicePaymentCheckout = '/dashboard/invoice/payment/:accountUuid/checkout';
export const invoicePaymentReturn = '/dashboard/invoice/payment/:accountUuid/return';
export const invoicingUI = '/dashboard/:businessEntityUuid/invoicing/*';
export const login = '/dashboard/login';
export const loginError = '/dashboard/login-error';
export const logout = '/dashboard/logout';
export const marketingTools = '/dashboard/:businessEntityUuid/marketing-tools/*';
export const meetingMinutes = '/dashboard/:businessEntityUuid/meeting-minutes';
export const mobileAccountNotFound = '/dashboard/account-not-found-mobile';
export const moneyLandingPage = '/dashboard/:businessEntityUuid/money';
export const paymentMethods = '/dashboard/:businessEntityUuid/subscription-hub/billing/methods';
export const taxServices = '/dashboard/:businessEntityUuid/money/tax-services/*';
export const unsupported = '/dashboard/unsupported';
export const unsupportedBrowsers = '/dashboard/unsupported-browsers';
export const userBlocked = '/dashboard/user-blocked';

// External routes — destinations outside the dashboard (e.g. www.zenbusiness.com).
// Uses [bracket] tokens (not :colon) to signal these are not react-router paths; replace at call site before passing to generateZenUrl.
export const VELO_GUIDE = '/guide/';
export const VELO_GUIDE_COMPANY = '/guide/company/[businessEntityUuid]';

export function isEntityUrl(path) {
  return (
    matchPath('/dashboard/:businessEntityUuid/*', path) &&
    !matchPath(accountSettings, path) &&
    !matchPath(billing, path) &&
    !matchPath(help, path)
  );
}
